export const resolveDefaultWorkspace = ({ workspaces = [], authUser = null, selectedWorkspace = null } = {}) => {
  if (!Array.isArray(workspaces) || workspaces.length === 0) {
    return null;
  }

  void authUser;
  const defaultWorkspace = workspaces.find(workspace => workspace?.is_default);

  if (defaultWorkspace) {
    return defaultWorkspace;
  }

  const selectedWorkspaceId = selectedWorkspace?.id;
  if (selectedWorkspaceId) {
    const currentWorkspace = workspaces.find(workspace => workspace.id === selectedWorkspaceId);
    if (currentWorkspace) {
      return currentWorkspace;
    }
  }

  return workspaces[0];
};
